import React, { useCallback, useEffect } from 'react';
import { IKlarityProgram } from 'types/programs';
import { getKlarityProgramDetail } from 'api/operation/programs';

const useGetProgramsDetail = (id: number):[IKlarityProgram|undefined, boolean, (id: number)=>void] => {
    const [loading, setLoading] = React.useState(false);
    const [item, setItem] = React.useState<IKlarityProgram>();
    const fetchData = useCallback(async (id: number) => {
        if (loading || !id) return;
        try {
            setLoading(true);
            const result = await getKlarityProgramDetail(id);
            if (!result.error) {
                const resData = result?.data?.data || [];

                setItem(resData);
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }, [loading]);

    useEffect(() => {
        fetchData(id);
    }, [id]);

    return [item, loading, fetchData];
};

export default useGetProgramsDetail;
